import { z } from 'zod';

const taxOfficeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});

export const getTaxOfficesSchema = z.array(taxOfficeSchema);

export type GetTaxOffices = z.infer<typeof getTaxOfficesSchema>;
